import { createScopeFromContext } from 'bunja/react';
import { createContext } from 'react';

import type AbstractSocket from '../../AbstractSocket';
import NullSocket from '../../NullSocket';
import type { V2SocketEvents } from './../types';

export const nullSocket = new NullSocket<V2SocketEvents>();
nullSocket.connect = () => {
  throw new Error(`A subscription attempt was detected without an R230522 socket being injected.
Please make sure to wrap your component with a <R230522Context> and provide an R230522 socket.`);
};

export const R230522Context = createContext<AbstractSocket<unknown, V2SocketEvents>>(nullSocket);
export const R230522Scope = createScopeFromContext(R230522Context);
